import { render } from "./MusicSidebar.vue?vue&type=template&id=38e6c6aa"
import script from "./MusicSidebar.vue?vue&type=script&lang=js"
export * from "./MusicSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__